export enum PaymentTypeEnum {
  CLIENT = 1,
  CASH_TERM = 2,
  BILLING_CODE = 3,
  DAYS = 4,
}
